"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (virtual) { return function (frame) {
    virtual.send('getTimerList');
    // 子设备设备完成登录
    virtual.emit('addSubDevResp', virtual, frame);
}; });



// WEBPACK FOOTER //
// ./src/actions/receive/actions/addSubDevResp.ts